
    import './styles.scoped.css';
    export default {
  "drag-overlay": "awsui_drag-overlay_1ksmw_1gcqi_141",
  "drag-overlay-item": "awsui_drag-overlay-item_1ksmw_1gcqi_145",
  "drag-overlay-container": "awsui_drag-overlay-container_1ksmw_1gcqi_170",
  "active": "awsui_active_1ksmw_1gcqi_196",
  "placeholder": "awsui_placeholder_1ksmw_1gcqi_206",
  "placeholder-item": "awsui_placeholder-item_1ksmw_1gcqi_215",
  "placeholder-container": "awsui_placeholder-container_1ksmw_1gcqi_221",
  "sorting": "awsui_sorting_1ksmw_1gcqi_228"
};
  